import React from 'react';
import ContextUser from '../../types/ContextUser';

interface UserContextProps {
  user: ContextUser | null;
  setUser: React.Dispatch<React.SetStateAction<ContextUser | null>>;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const UserContext = React.createContext<UserContextProps>({
  user: null,
  setUser: () => {},
  isLoading: true,
  setIsLoading: () => {}
});

export default UserContext;
